/**
 * Generate array of years
 *
 * @param {String} start Start year
 * @param {String} stop End year
 * @param {String} step Iterate step
 * @returns {Array} Return array of years
 */
export default function (start = 1970, stop, step) {
  return Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step)
}
